// Configure API URL based on environment
// In production, use relative paths to leverage Vercel's proxy
// In development, use the full URL from env vars
const isProduction = import.meta.env.MODE === 'production';
const API_URL = isProduction ? '' : (import.meta.env.VITE_API_URL || 'http://localhost:3002');

interface ApiOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: any;
  headers?: Record<string, string>;
}

export async function api<T>(endpoint: string, options: ApiOptions = {}): Promise<T> {
  const token = localStorage.getItem('token');
  
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...options.headers,
  };

  console.log(`Making ${options.method || 'GET'} request to ${API_URL}${endpoint}`);
  console.log('Headers:', headers);
  if (options.body) {
    console.log('Request body:', options.body);
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: options.method || 'GET',
      headers,
      ...(options.body ? { body: JSON.stringify(options.body) } : {}),
    });

    const data = await response.json();
    
    if (!response.ok) {
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText,
        data
      });
      throw new Error(data.message || 'API request failed');
    }

    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('API request failed:', {
      endpoint,
      error: error instanceof Error ? error.message : 'Unknown error'
    });
    throw error;
  }
}

// Example usage:
// const meetings = await api<Meeting[]>('/api/meetings');
// const newMeeting = await api<Meeting>('/api/meetings', {
//   method: 'POST',
//   body: meetingData
// }); 